import { type FC, Suspense } from 'react';
import { usePreloadedQuery, type PreloadedQuery } from 'react-relay';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer.tsx';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton.tsx';

import { SellerReviewsModalContent } from './SellerReviewsModalContent/SellerReviewsModalContent.tsx';
import { SellerReviewsMobileModalContent } from './SellerReviewsModalContent/SellerReviewsMobileModalContent.tsx';
import { Query } from './SellerReviewsModalQuery.ts';

import { type SellerReviewsModalQuery } from './__generated__/SellerReviewsModalQuery.graphql.ts';

const SellerReviewsModal: FC<{
    onClose: () => void;
    contentOnly: boolean;
    isOpen: boolean;
    sellerId: string;
    isMobileScrollContainer: boolean;
    queryReference: PreloadedQuery<SellerReviewsModalQuery>;
    noTabs?: boolean;
}> = ({
    isOpen,
    contentOnly = false,
    onClose,
    sellerId,
    isMobileScrollContainer,
    queryReference,
    noTabs,
}) => {
    const { viewer } = usePreloadedQuery<SellerReviewsModalQuery>(Query, queryReference);

    const ReviewModalContent = isMobileScrollContainer
        ? SellerReviewsMobileModalContent
        : SellerReviewsModalContent;

    if (contentOnly) {
        return (
            <ReviewModalContent viewer={viewer} sellerId={sellerId} contentOnly noTabs={noTabs} />
        );
    }

    return (
        <ModalContainer isOpen={isOpen} onClose={onClose} modalSize="medium">
            <ModalCloseButton onClick={onClose} />

            <Suspense fallback={<ReviewModalContent viewer={null} sellerId={sellerId} isLoading />}>
                <ReviewModalContent viewer={viewer} sellerId={sellerId} noTabs={noTabs} />
            </Suspense>
        </ModalContainer>
    );
};

export default SellerReviewsModal;
